"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTotalCountAndCost = exports.calculateCostTotal = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _utils = require("../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var calculateCostTotal = function calculateCostTotal(cost) {
  return (0, _utils.safeMult)(cost.price, cost.quantity);
};
exports.calculateCostTotal = calculateCostTotal;
var getTotalCountAndCost = function getTotalCountAndCost(firstTier, aggregates) {
  var totalCount = 0;
  var totalCost = 0;
  var actualCosts = [];
  var getCostItem = function getCostItem(item) {
    var costs = _lodash.default.flattenDeep(_lodash.default.get(item, 'cost'));
    var hasCosts = _lodash.default.some(costs, function (cost) {
      return calculateCostTotal(cost) > 0;
    });
    if (hasCosts) {
      actualCosts.push(costs);
      totalCount++;
    }
  };
  getCostItem(firstTier);
  _lodash.default.forEach(_lodash.default.values(_lodash.default.get(firstTier, 'children')), function (secondTier) {
    getCostItem(secondTier);
    _lodash.default.forEach(_lodash.default.values(_lodash.default.get(secondTier, 'children')), function (thirdTier) {
      getCostItem(thirdTier);
    });
  });
  actualCosts = _lodash.default.flatten(actualCosts);
  _lodash.default.forEach(actualCosts, function (cost) {
    totalCost = (0, _utils.safeAdd)(totalCost, calculateCostTotal(cost));
  });
  aggregates.aggregratedtotalCount += totalCount;
  aggregates.aggregratedtotalCost += totalCost;
  return [totalCount, (0, _utils.convertValueToDollar)(totalCost), aggregates.aggregratedtotalCount, (0, _utils.convertValueToDollar)(aggregates.aggregratedtotalCost)];
};
exports.getTotalCountAndCost = getTotalCountAndCost;